import React from 'react';
import { Login as NewLogin } from '@cokitchen/cokitchen-auth';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const LOGIN_URL = 'internal/auth/login-marketing';

const Login = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = async () => {
    navigate(ROUTE_KEYS.HOME);
  };

  return (
    <div className='login-container w-full bg-red-9 p-4 md:overflow-auto'>
      <section className='auth-login__card px-8 md:px-16'>
        <NewLogin
          dashboard='marketing'
          onLogin={handleLoginSuccess}
          title='Login to your dashboard'
          LOGIN_URL={LOGIN_URL}
          API_URL={process.env.REACT_APP_API_URL}
          API_KEY={process.env.REACT_APP_API_KEY}
        />
      </section>
    </div>
  );
};

export default Login;
